export default (state = {}, payload) => {
  switch (payload.type) {
    case "LOAD_CONFIG_SUCCESS":
      console.log(payload.data);
      return payload.data;

    default:
      return state;
  }
};
